export default "__VITE_ASSET__D27XsYde__"